import { Component } from '@angular/core';

@Component({
  selector: 'app-hero-morbilidad',
  standalone: true,
  imports: [],
  templateUrl: '../../hero-empresarial/hero-empresarial.component.html',
  styleUrl: './hero-morbilidad.component.css'
})
export class HeroMorbilidadComponent {

  name="Morbilidad";
  description = "Permite identificar las enfermedades y condiciones de salud más comunes entre los colaboradores, ayudando a tomar decisiones informadas para mejorar su bienestar y productividad.";
  description2 = "";
  routeLogo = "/assets/img/enterprise/menu/indicadoresDeMorbilidad.svg";
  routeImage = "assets/img/enterprise/hero/fotoMorbilidad.svg"


}
